import { render, staticRenderFns } from "./ExpiryLabel.vue?vue&type=template&id=3b86a7a2&scoped=true&"
import script from "./ExpiryLabel.vue?vue&type=script&lang=js&"
export * from "./ExpiryLabel.vue?vue&type=script&lang=js&"
import style0 from "./ExpiryLabel.vue?vue&type=style&index=0&id=3b86a7a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86a7a2",
  null
  
)

export default component.exports